import React from 'react'

const Break: React.FC = () => {
  return (
    <div className='break-wrapper'>
      <div className='break'></div>
    </div>
  )
}

export default Break
